<template>
  <div class="extraCostPage">
    <Row :gutter="24" style="margin-bottom:16px;">
      <Col :span="10">实收总计：{{realIncome}}</Col>
      <Col :span="10"></Col>
      <Col :span="2"><Button type="primary" :disabled="!disAdditionalCost || settlementStatusFlag" @click="addExtraCost">新增耗材</Button></Col>
    </Row>
    <Row :gutter="24">
      <Col :span="24">
        <Table :dataSource="tableData" :columns=columns :pagination="false" rowKey="orderCheckId" size="middle" border>
          <template slot="createDate" slot-scope="text, record">
            <span>{{record.orderCheckMaterialList[0].created_date}}</span>
          </template>
          <template slot="detail" slot-scope="text, record">
            <div v-for="(val, index) in record.orderCheckMaterialList" :key="index">{{val.hospital_medical_image_center_material_name}} {{val.manufacter}}(数量：{{val.cost_count}})</div>
          </template>
          <template slot="diagnoseCost" slot-scope="text, record">
            <span>{{record.priceTotal}}</span>
          </template>
          <template slot="actualCost" slot-scope="text, record">
            <span>{{record.price}}</span>
          </template>
          <template slot="payStatus" slot-scope="text, record">
            <span>{{record.chargeChannel}} {{record.paymentStatus|getPayStatusData}}</span>
          </template>
          <template slot="control" slot-scope="text, record">
            <span style="color: #1890ff; text-decoration: underline;margin-right:10px;" @click="editExtraCost(record)" v-if="(((record.chargeChannel !== '线上-支付宝' && record.chargeChannel !== '线上-微信') && record.paymentStatus === 20) && !settlementStatusFlag) || ((record.paymentStatus === 10) && !settlementStatusFlag)">编辑</span>
            <span style="color: #1890ff; text-decoration: underline;" @click="deleteConsum(record)" v-if="(((record.chargeChannel !== '线上-支付宝' && record.chargeChannel !== '线上-微信') && record.paymentStatus === 20) && !settlementStatusFlag) || ((record.paymentStatus === 10) && !settlementStatusFlag)">删除</span>
          </template>
        </Table>
      </Col>
    </Row>
    <div slot="footer" class="footer">
      <Button type="primary" size="large" @click="goBack">返回</Button>
    </div>
    <Modal :title="modalTitle" v-model="showAddModal" :footer="null" :width="680">
      <addExtra v-if="showAddModal" :editInfo="editInfo" @closeAddPrice="closeAddPrice" @saveSuccsee='saveSuccsee' :checkOrderId='checkOrderId'></addExtra>
    </Modal>
  </div>
</template>

<script>
import addExtra from './addExtraCost'
import { Row, Col, Table, Button, Modal } from 'ant-design-vue'
import { getOtherPrice, removePriceConsumOrder } from '../../api/historyCheck'
export default {
  props: {
    checkOrderId: {
      type: Number,
      default: 0
    },
    disAdditionalCost: {
      type: Boolean,
      default: true
    },
    settlementStatus: {
      type: Number,
      default: 0
    }
  },
  components: {
    Row,
    Col,
    Table,
    Button,
    addExtra,
    Modal,
  },
  data () {
    return {
      tableData: [],
      columns: [
        {
          title: '创建时间',
          dataIndex: 'created_date',
          scopedSlots: { customRender: 'createDate' }
        },
        {
          title: '明细',
          dataIndex: 'detail',
          scopedSlots: { customRender: 'detail' }
        },
        {
          title: '医疗费用',
          dataIndex: 'diagnoseCost',
          scopedSlots: { customRender: 'diagnoseCost' }
        },
        {
          title: '实际费用',
          dataIndex: 'actualCost',
          scopedSlots: { customRender: 'actualCost' }
        },
        {
          title: '支付状态',
          dataIndex: 'payStatus',
          scopedSlots: { customRender: 'payStatus' }
        },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' },
        }
      ],
      showAddModal: false,
      realIncome: '',
      editInfo: {},
      modalTitle: '新增额外费用',
      settlementStatusFlag: false
    }
  },
  async mounted () {
    if (this.checkOrderId) {
      await this.getConsumPriceList()
      if (this.settlementStatus.toString() === '0') {
        this.settlementStatusFlag = false
      } else {
        this.settlementStatusFlag = true
      }
    }
  },
  methods: {
    // 获取耗材费用列表
    async getConsumPriceList () {
      let data = await getOtherPrice({ orderCheckId: this.checkOrderId })
      if (data.checkMaterialDetailsVoList) {
        data.id = (new Date()).getTime()
        this.tableData = data.checkMaterialDetailsVoList
        this.realIncome = data.totalCharges
      } else {
        this.tableData = []
        this.realIncome = ''
      }
    },
    // 新增额外费用
    addExtraCost() {
      this.editInfo = {
        addFlag: true
      }
      this.modalTitle = '新增额外费用'
      this.showAddModal = true
    },
    // 新增成功
    saveSuccsee () {
      this.showAddModal = false
      this.getConsumPriceList()
    },
    // 编辑额外费用
    editExtraCost (record) {
      if (this.disAdditionalCost) {
        record.addFlag = false
        this.editInfo = record
        this.showAddModal = true
        this.modalTitle = '编辑额外费用'
      }
    },
    // 删除额外费用
    async deleteConsum (record) { 
      if (this.disAdditionalCost) {
        let data = await removePriceConsumOrder({ orderCheckId: record.orderCheckId })
        if (data) this.getConsumPriceList()
      }
    },
    // 关闭新增弹框
    closeAddPrice () {
      this.showAddModal = false
      this.getConsumPriceList()
    },
    // 返回
    goBack () {
      this.$emit('closeExtraCost')
    }
  }
}
</script>

<style lang="less">
.extraCostPage{
  .footer{
    text-align: right;
    margin-top: 20px;
  }
}
</style>